var request = require('../request')
var tootTip = require('../tooltip')
var raygun = require('../raygun');

var timeout;

// Ensure only one request at a time being process at anytime
var activeRequest = false

// TBC Following modules
//var ui = require('../../photo-upload-ui')
//var spinner = require('./spinner').spinner

// Given there is an ajax call
// When the call is started
// Then show the spinner

var onloadstartHandler = function () {
  //ui.overlay && (ui.overlay.hidden = true)
  //spinner.hidden = false
  console.log("Show spinner")
}

// TBC
// Given there is an ajax call in progress
// When there is a progress event
// Then update the textContent in the progressbar

var onprogressHandler = function (e) {
  console.log("Show spinner" + (e.loaded / e.total * 100 >> 0))
}

// TBC
// Given there is an ajax call
// When the call is completed
// Then hide the progressbar

var onloadendHandler = function () {
  console.log("Hide spinner")
}


var resolve = function (target, res) {
  if(res.length > 0){
    activeRequest = false
    var parent = target.parentElement
    var content = document.createRange().createContextualFragment(res)
    parent.replaceChild(content, target)
    tootTip.reInit();
  }
}

var errorHandling = function (e) {
  activeRequest = false
}

function init() {
  window.addEventListener('scroll', function(){
    timeout = window.setTimeout(show(), 500)
  });
  show()
}

function load(target, url) {
  activeRequest = true
  request.get(url, {onloadstartHandler:onloadstartHandler, onprogressHandler:onprogressHandler})
    .then(function (res) {
      onloadendHandler()
      return res
    })
    .then(function (res) {
      resolve(target, res)
    })
    .catch(function (err) {
      errorHandling(err)
      raygun.sendError(error, 'similarMembers');
    })
}

function show() {
  if(timeout){
    window.clearTimeout(timeout)
  }
  var target = document.querySelector('[data-similar-members-url]');
  if (target) {
    var profileIssues = (target.dataset.profileIssues == 'true')? true : false;
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var pageHeight = document.body.clientHeight;
    if (!activeRequest && scrollTop >= (pageHeight / 2) && target.innerHTML === '' || profileIssues) {
      load(target, target.dataset.similarMembersUrl)
    }
  }
}

document.addEventListener('DOMContentLoaded', init);
